import { render, staticRenderFns } from "./UPCaveatPreview.vue?vue&type=template&id=2e1d3542&scoped=true"
import script from "./UPCaveatPreview.vue?vue&type=script&lang=js"
export * from "./UPCaveatPreview.vue?vue&type=script&lang=js"
import style0 from "./UPCaveatPreview.vue?vue&type=style&index=0&id=2e1d3542&prod&lang=scss&scoped=true"
import style1 from "./UPCaveatPreview.vue?vue&type=style&index=1&id=2e1d3542&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d3542",
  null
  
)

export default component.exports